import React, { useEffect, useState } from 'react';
import { EyeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
// ── Global Visitor Counter (shared across all visitors via counterapi.dev) ──
export function VisitorStats() {
  const {
    language
  } = useLanguage();
  const isEs = language === 'ES';
  const [visitorCount, setVisitorCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const SESSION_KEY = 'haa_global_counted_2025';
    const LOCAL_KEY = 'haa_global_count_cache_2025';
    const alreadyCounted = sessionStorage.getItem(SESSION_KEY);
    // If already counted this session, just read the count (don't increment again)
    const endpoint = alreadyCounted ? 'https://api.counterapi.dev/v1/haa-honduran-association/site-visits-2025' : 'https://api.counterapi.dev/v1/haa-honduran-association/site-visits-2025/up';
    fetch(endpoint).then(res => res.json()).then(data => {
      const count = data?.count ?? 0;
      setVisitorCount(count);
      localStorage.setItem(LOCAL_KEY, String(count));
      if (!alreadyCounted) {
        sessionStorage.setItem(SESSION_KEY, 'true');
      }
    }).catch(() => {
      // Fallback: show cached count from localStorage
      const cached = localStorage.getItem(LOCAL_KEY);
      setVisitorCount(cached ? parseInt(cached, 10) : 0);
    }).finally(() => setLoading(false));
  }, []);
  return <div className="flex items-center justify-center" data-id="element-3300">
      <div className="flex items-center gap-2.5 bg-white/5 border border-white/10 rounded-xl px-4 py-2.5" data-id="element-3301">
        <div className="w-7 h-7 rounded-lg bg-haa-blue/30 flex items-center justify-center" data-id="element-3302">
          <EyeIcon className="w-3.5 h-3.5 text-haa-skyblue" data-id="element-3303" />
        </div>
        <div data-id="element-3304">
          <p className="font-nunito text-[10px] uppercase tracking-wider text-white/30 leading-none mb-0.5" data-id="element-3305">
            {isEs ? 'Visitas Totales' : 'Total Visits'}
          </p>
          {loading ? <div className="w-12 h-4 bg-haa-skyblue/20 rounded animate-pulse" data-id="element-3306" /> : <p className="font-bebas text-lg text-haa-skyblue tracking-wider leading-none" data-id="element-3307">
              {visitorCount.toLocaleString()}
            </p>}
        </div>
      </div>
    </div>;
}